<ng-container *ngIf="!isLoading && availableImportTypes.length">
    <!-- BUTTON STYLE LAUNCHER: Will display a button for one import option, and a dropdown for multiple import options -->
    <ng-container *ngIf="launcherStyle === 'BUTTON'">
        <ui-button
            type="primary"
            [matMenu]="hasMultipleImportFlows ? integrationsMenu : null"
            (click)="hasMultipleImportFlows ? undefined : handleClick(availableImportTypes[0], $event)"
            >{{ 'import.launcher' | translate }}
            <mat-icon class="margin-left-1" *ngIf="hasMultipleImportFlows" svgIcon="chevronDown"></mat-icon
        ></ui-button>

        <mat-menu #integrationsMenu xPosition="before">
            <button *ngFor="let importType of availableImportTypes" mat-menu-item>
                <ng-container *ngIf="IMPORT_CONFIGS[importType] as menuItem">
                    <a class="integration-menu-item" (click)="handleClick(importType, $event)">
                        <mat-icon *ngIf="menuItem.icon" [svgIcon]="menuItem.icon"></mat-icon>
                        {{ 'import.types.' + importType + '.title.' + labelLength | translate }}
                    </a>
                </ng-container>
            </button>
        </mat-menu>
    </ng-container>

    <!-- TILE STYLE LAUNCHER: Will display a tile for each import option -->
    <div class="tile-container" *ngIf="launcherStyle === 'TILE'">
        <ui-card
            *ngFor="let importType of availableImportTypes"
            [withMargin]="false"
            (click)="handleClick(importType, $event)"
        >
            <ng-container *ngIf="'import.types.' + importType | translate as translation">
                <h3 class="margin-bottom-1">{{ translation.title?.[labelLength] }}</h3>
                {{ translation.description }}
            </ng-container>
        </ui-card>
    </div>
</ng-container>
